import { render, staticRenderFns } from "./featured-resources-widget.vue?vue&type=template&id=41bf3f94"
import script from "./featured-resources-widget.vue?vue&type=script&lang=ts"
export * from "./featured-resources-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports